import { render } from "./MyAccountSecurity.vue?vue&type=template&id=21b9e782"
import script from "./MyAccountSecurity.vue?vue&type=script&lang=js"
export * from "./MyAccountSecurity.vue?vue&type=script&lang=js"

import "./MyAccountSecurity.vue?vue&type=style&index=0&id=21b9e782&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/MyAccountSecurity.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21b9e782"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21b9e782', __exports__)) {
    api.reload('21b9e782', __exports__)
  }
  
  module.hot.accept("./MyAccountSecurity.vue?vue&type=template&id=21b9e782", () => {
    api.rerender('21b9e782', render)
  })

}


export default __exports__